module.exports = __webpack_public_path__ + "img/Schedule-Gif.97099357.gif";